import React, {useEffect, useReducer, createContext, useContext} from 'react';

export const VehicleStateContext = createContext(null);

export const VehicleStateProvider = ({reducer, initialState, children}) => (
    <VehicleStateContext.Provider value={reducer}>
        {children}
    </VehicleStateContext.Provider>
);

export const useStateValue = () => useContext(VehicleStateContext);